import React, { useState } from 'react'
import { Modal } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ProductModal from '../../components/ProductModal'
import { AndroidButton } from '../../../../components/common/AndroidButton'
import { AppStoreButton } from '../../../../components/common/AppStoreButton'
import { CancelIcon } from '../../../../components/svgs/Svgs'

// eslint-disable-next-line react/prop-types,import/prefer-default-export
export function ProductCard({ index, title, text, whiteImg, off, text2, text3, android, ios, blackImg, video, universalImg }) {
    const { t } = useTranslation()
    const [open, setOpen] = useState(false)
    return (
        <div className={`flex sm:flex-col ${Number(index) % 2 === 0 ? ''
            + 'md:flex-row-reverse' : 'md:flex-row'} w-[100%] sm:gap-[14px] items-center md:gap-[50px]`}
        >
            <div className={`w-full md:w-[500px] lg:w-[730px] h-[205px] md:h-[400px] 
  ${!universalImg && !whiteImg && !blackImg ? 'bg-[#F4F4F4] dark:bg-[#515151]' : ''}`}
            >

                {universalImg ? (
                    <img
                        src={universalImg}
                        alt="img of the mine"
                        loading="lazy"
                        className="w-full h-full object-contain"
                    />
                ) : (
                    <>
                        {whiteImg && (
                            <img
                                src={whiteImg}
                                alt="white version"
                                loading="lazy"
                                className="w-full h-full object-contain hidden dark:block"
                            />
                        )}
                        {blackImg && (
                            <img
                                src={blackImg}
                                alt="black version"
                                loading="lazy"
                                className="w-full h-full object-contain block dark:hidden"
                            />
                        )}
                    </>
                )}
            </div>

            <div className="flex flex-col items-start gap-[22px]">
                <div className="flex flex-col w-[100%] md:w-[400px] lg:w-[615px] items-start gap-[10px]">
                    <span className="text-[14px] sm:hidden md:block font-[400] text-[#0068B5] dark:text-white">
                        №
                        {index}
                    </span>
                    <span className="text-[18px] lg:text-[50px] font-[700]
                    lg:font-[300] text-black dark:text-white"
                    >
                        {title}
                    </span>
                    <span className="text-[#525252] dark:text-white w-[100%] font-normal text-[16px]">
                        {text}
                    </span>
                    <span className="text-[#525252] dark:text-white w-[100%] font-normal text-[16px]">
                        {text2}
                    </span>
                    <span className="text-[#525252] dark:text-white w-[100%] font-normal text-[16px]">
                        {text3}
                    </span>
                </div>
                <div className={`flex ${ios ? 'flex-col items-start' : 'flex-row items-center'}  gap-[20px]`}>
                    {!off === true && (
                        <ProductModal id={Number(index)} xl />
                    )}
                    <div className="flex  items-center gap-[20px]">
                        {android && (
                            <AndroidButton link={android} />
                        )}
                        {ios && (
                            <AppStoreButton link={ios} />
                        )}
                    </div>
                    {video && (
                        <button
                            onClick={() => setOpen(true)}
                            className="text-[#0068B5] hover:bg-[#0068B5] hover:text-white transition-all
                         duration-300 ease-in-out border border-[#0068B5] rounded-[10px] px-[10px] py-[10px]"
                        >
                            {t('landing.products.videoTitle')}
                        </button>
                    )}
                </div>
            </div>

            {/* Modal */}
            {video && (
                <Modal open={open} onClose={() => setOpen(false)}>
                    <div className="fixed inset-0 flex items-center justify-center p-4">
                        <div className="bg-white relative dark:bg-[#1e1e1e] p-4 rounded-xl max-w-[90%]
                         max-h-[90%] w-[800px] h-[350px] md:h-[450px] shadow-lg"
                        >
                            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                            <video controls autoPlay className="w-full h-full rounded-lg">
                                <source src={video} />
                                Your browser does not support the video tag.
                            </video>
                            <div
                                onClick={() => setOpen(false)}
                                className="p-[17.5px] absolute top-[-60px] left-0 xl:top-0 xl:left-[-60px]
                                cursor-pointer bg-[#F7F7F7] rounded-[34px]"
                            >
                                <CancelIcon />
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
        </div>
    )
}
